import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  namespaced: true,
  state: {
    profile: null,
    saving: false,
    error: false,
    success: false
  },
  mutations: {
    set_profile(state, payload) {
      // Format all the weights
      let profile = payload.p;
      profile.w = (payload.p.w/10).toFixed(1);
      profile.g = (payload.p.g/10).toFixed(1);
      profile.c = (payload.p.c/10).toFixed(1); // TODO: This is actually the incorrect one and should be last weigh-in!! Fixe bug in weigh-in

      profile.d.forEach(diet => {
        diet.s.forEach(step => {
          step.g = (step.g/10).toFixed(1);
        });
      });

      state.profile = profile;
      state.currentDiet = profile.d.reduce((a, b) => new Date(a.d) > new Date(b.d) ? a : b);
    },
    set_current_weight(state, payload) {
      state.profile.c = payload;
    },
    saving(state, payload) {
      state.saving = payload;
    },
    clearMessages(state) {
      state.error = false;
      state.success = false;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setSuccess(state, payload) {
      state.success = payload;
    },
    subscribeProfileUpdates(state, payload) {
      state.unsubscribeProfile = payload
    },
    unsubscribeProfileUpdates(state) {
      if (state.unsubscribeProfile) {
        state.unsubscribeProfile();
        state.unsubscribeProfile = undefined;
      }
    }
  },
  actions: {
    // send({commit}, payload) {
    // }
    saveProfile({commit, state, rootState}) {
      commit('saving', true);

      // Set the weights as centigram - Deep copy first
      let new_profile = JSON.parse(JSON.stringify(state.profile));
      new_profile.w = state.profile.w * 10;
      new_profile.g = state.profile.g * 10;
      new_profile.c = state.profile.c * 10;

      new_profile.d.forEach(diet => {
        diet.s.forEach(step => {
          step.g = step.g * 10;
        });
      });

      // Save to Firebase
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      profileDoc.set({p: new_profile})
      .then(() => commit('setSuccess', true))
      .catch((e) => commit('setError', e))
      .finally(() => commit('saving', false))
    }
  },
  getters: {
    // sent(state) {
    //   return state.sent
    // }
    stepGoals(state){
      return state.currentDiet.s.sort((a, b) => a.g > b.g);
    },
  }
}